// extracted by mini-css-extract-plugin
export default {"wrapper":"PatientSelectionDialog_wrapper__rHvvj","patientSelectBtn":"PatientSelectionDialog_patientSelectBtn__pu7jL","buttons":"PatientSelectionDialog_buttons__3c1d5"};